module.exports = __webpack_public_path__ + "berlin-map.553b23e9ee5ab98581820d53d7972f7f.svg";